"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Typography_1 = require("@material-ui/core/Typography");
const react_i18next_1 = require("react-i18next");
const QuickDrawGameCardStyle_1 = require("../../jss/QuickDrawGameCardStyle");
const WinningNumber = ({ visible, winningNumber, showPrize, prize, prizeText }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const classes = (0, QuickDrawGameCardStyle_1.default)();
    if (!visible) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)("div", { children: [!!showPrize && ((0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "subtitle1", gutterBottom: true, color: 'textPrimary', className: classes.winningNumberText, component: 'div' }, { children: `${prizeText !== null && prizeText !== void 0 ? prizeText : t('gameDetails.prize')}: $${prize}` }))), !!winningNumber && !!winningNumber.data && ((0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "subtitle1", gutterBottom: true, color: 'textPrimary', className: classes.winningNumberText, component: 'div' }, { children: `${t('gameDetails.winningNumber')}: ${parseInt(winningNumber.data, 10)}` })))] }));
};
exports.default = WinningNumber;
//# sourceMappingURL=WinningNumber.js.map